import FormTextArea from 'components/new-ui/composed/formTextArea/FormTextArea';
import CustomModal from 'components/ui/base/modal/Modal';
import { H5 } from 'components/ui/base/typography';
import { useFormik } from 'formik';
import * as Yup from 'yup';

type AmendmentReasonModalProps = {
    open?: boolean;
    onCancel?: () => void;
    onSubmit: (values: { detailsAmended: string }) => void;
};

const AmendmentReasonModal = ({ open = false, onCancel = () => {}, onSubmit }: AmendmentReasonModalProps) => {
    const formik = useFormik({
        initialValues: { detailsAmended: '' },
        enableReinitialize: true,
        validateOnMount: true,
        validateOnChange: false,
        validationSchema: Yup.object().shape({
            detailsAmended: Yup.string().nullable().max(512),
        }),
        onSubmit: async (values: { detailsAmended: string }) => onSubmit?.(values),
    });

    return (
        <CustomModal
            title={<H5>Amendment Reason</H5>}
            centered
            cancelText="Cancel"
            confirmText="Continue"
            testId="amendment-reason-modal"
            open={open}
            disabledOkButton={formik.isSubmitting}
            onOk={() => {
                formik.submitForm();
            }}
            onCancel={() => {
                formik.resetForm();
                onCancel?.();
            }}
            width={676}
        >
            <FormTextArea
                autoSize={{ minRows: 6, maxRows: 12 }}
                placeholder="Enter amendment reason"
                fieldProps={formik.getFieldProps('detailsAmended')}
            />
        </CustomModal>
    );
};

export default AmendmentReasonModal;
